import { ApplicationConfig, mergeConfigs } from '../interface/response/ApplicationConfig';
import { ApiConsumer } from '../service/api-consumer';
import { AgmsResponseCode } from '../enum/AgmsResponseCode';
import { getConfigFromLocalStorage, setConfigToLocalStorage } from './local-storage';
import { AppDispatch } from '../store/store';
import { updateConfig } from '../store/slice/config/config';

export async function updateApplicationConfig(config: ApplicationConfig, dispatch: AppDispatch) {
  try {
    const applicationConfigResponse = await ApiConsumer.getConfig();

    if (applicationConfigResponse.ResponseCode === AgmsResponseCode.OK) {
      const appConfig = applicationConfigResponse.Config;
      const updatedConfig = mergeConfigs(appConfig, config);
      await dispatch(updateConfig(updatedConfig));
    } else {
      throw new Error();
    }
  } catch (error) {
    const localConfig = getConfigFromLocalStorage();
    const mergedConfig = mergeConfigs(localConfig || {}, config);
    setConfigToLocalStorage(mergedConfig);
  }
}
